import React, { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUserRole } from "../../hooks/useUserRole";
import { PREMIUM_TRANSLATION_FULL_PATH, QUICK_TRANSLATE_FULL_PATH } from "../../utils/menuPathNormalize";

/**
 * 旧 path `/quick-translate`：操作者重定向到精品译制，其余进入工作台内一键速译列表。
 */
export const QuickTrans: FC = () => {
  const navigate = useNavigate();
  const { isOperator, isAdmin, isAssessor, isLoading: roleLoading } = useUserRole();

  useEffect(() => {
    if (roleLoading) return;
    if (isOperator && !isAdmin && !isAssessor) {
      navigate(PREMIUM_TRANSLATION_FULL_PATH, { replace: true });
      return;
    }
    navigate(QUICK_TRANSLATE_FULL_PATH, { replace: true });
  }, [roleLoading, isOperator, isAdmin, isAssessor, navigate]);

  return null;
};
